module.exports = __webpack_public_path__ + "img/delivery.d3f553c5.svg";